// Runtime configuration
// This file reads from window._env_ which is set at runtime via env-config.js

const getConfig = () => {
  // Check if runtime config is available (from env-config.js)
  if (window._env_ && window._env_.REACT_APP_API_URL) {
    return {
      API_BASE_URL: window._env_.REACT_APP_API_URL,
      TRAINING_BASE_URL:
        window._env_.REACT_APP_API_TRAIN_URL ||
        window._env_.REACT_APP_TRAINING_BASE_URL ||
        "http://localhost:8001",
    };
  }

  // Fall back to build-time environment variables for local development
  return {
    API_BASE_URL:
      process.env.REACT_APP_API_BASE_URL ||
      process.env.REACT_APP_API_URL ||
      "http://localhost:8000",
    TRAINING_BASE_URL:
      process.env.REACT_APP_API_TRAIN_URL ||
      process.env.REACT_APP_TRAINING_BASE_URL ||
      "http://localhost:8001",
  };
};

const config = getConfig();

// Backend and Training services are on separate servers
// Backend service: port 8000
// Training service: port 8001
export const API_BASE_URL = config.API_BASE_URL;
export const TRAINING_BASE_URL = config.TRAINING_BASE_URL;

export default config;
